import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'client/_redux/reducers';
import {
  getAllCategoryTours,
  addCategoryTour,
  updateCategoryTour,
  deleteCategoryTourById,
} from 'client/_redux/actions/categoryTour';
import ICategoryTourForm from 'client/models/ICategoryTourForm';
import { ICategoryTour } from 'client/models/ICategoryTour';

export const useCategoryTourManagement = () => {
  const dispatch = useDispatch();
  const { allCategoryTours } = useSelector((state: RootState) => state.categoryTour);

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState<ICategoryTour | null>(null);
  const [formData, setFormData] = useState<ICategoryTourForm>({
    name: '',
    description: '',
  });

  // Charger toutes les catégories au montage
  useEffect(() => {
    dispatch(getAllCategoryTours());
  }, [dispatch]);

  // Ouvrir le formulaire pour créer une nouvelle catégorie
  const handleOpenCreateForm = () => {
    setEditingCategory(null);
    setFormData({ name: '', description: '' });
    setIsFormOpen(true);
  };

  // Ouvrir le formulaire pour modifier une catégorie
  const handleOpenEditForm = (category: ICategoryTour) => {
    setEditingCategory(category);
    setFormData({
      name: category.name,
      description: category.description,
    });
    setIsFormOpen(true);
  };

  // Fermer le formulaire
  const handleCloseForm = () => {
    setIsFormOpen(false);
    setEditingCategory(null);
    setFormData({ name: '', description: '' });
  };

  // Gérer les changements dans le formulaire
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Soumettre le formulaire
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (editingCategory) {
      // Mise à jour
      dispatch(updateCategoryTour(editingCategory._id, formData));
    } else {
      // Création
      dispatch(addCategoryTour(formData));
    }

    handleCloseForm();
  };

  // Supprimer une catégorie
  const handleDelete = (categoryId: string) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette catégorie ?')) {
      dispatch(deleteCategoryTourById(categoryId));
    }
  };

  return {
    allCategoryTours,
    isFormOpen,
    editingCategory,
    formData,
    handleOpenCreateForm,
    handleOpenEditForm,
    handleCloseForm,
    handleInputChange,
    handleSubmit,
    handleDelete,
  };
};
